<ion-header>
  <ion-toolbar>
    <ion-title>Filter</ion-title>
    <ion-button slot="end" fill="clear" size="small" style="font-size: smaller;" (click)="resetFilter();">zurücksetzen</ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item-divider>
      <ion-label>
        Angebotsgruppen
      </ion-label>
      <ion-button slot="end" fill="clear" *ngIf="iGroups.length !== 0" size="small" style="font-size: smaller;" (click)="iGroups = [];">Alle einblenden</ion-button>
      <ion-button slot="end" fill="clear" *ngIf="iGroups.length === 0" size="small" style="font-size: smaller;" (click)="setAllInvisible();">Alle ausblenden</ion-button>
    </ion-item-divider>
    <ion-item *ngFor="let group of groups" (click)="toggleArtikelGruppe(group)">
      <ion-icon slot="start" [name]="iGroups.indexOf(group) === -1 ? 'checkbox-outline' : 'square-outline'"></ion-icon>
      <ion-label>
        {{group}}
      </ion-label>
    </ion-item>
    <ng-container *ngIf="nichtVerfuegbareVorhanden">
      <ion-item-divider>
        <ion-label>
          Verfügbarkeit
        </ion-label>
      </ion-item-divider>
      <ion-item (click)="setVerfuegbarkeitAlle(true)">
        <ion-icon slot="start" [name]="verfuegbarkeitAlle ? 'checkbox-outline' : 'square-outline'"></ion-icon>
        <ion-label>
          Alle anzeigen
        </ion-label>
      </ion-item>
      <ion-item (click)="setVerfuegbarkeitAlle(false)">
        <ion-icon slot="start" [name]="verfuegbarkeitAlle ? 'square-outline' : 'checkbox-outline'"></ion-icon>
        <ion-label>
          Nur verfügbare anzeigen
        </ion-label>
      </ion-item>
    </ng-container>
    <ng-container *ngIf="topVorhanden">
      <ion-item-divider>
        <ion-label>
          Topartikel
        </ion-label>
      </ion-item-divider>
      <ion-item (click)="nurTop = false;">
        <ion-icon slot="start" [name]="!nurTop ? 'checkbox-outline' : 'square-outline'"></ion-icon>
        <ion-label>
          Alle anzeigen
        </ion-label>
      </ion-item>
      <ion-item (click)="nurTop = true;">
        <ion-icon slot="start" [name]="!nurTop ? 'square-outline' : 'checkbox-outline'"></ion-icon>
        <ion-label>
          Nur Topartikel anzeigen
        </ion-label>
      </ion-item>
    </ng-container>
    <ion-item-divider>
      <ion-label>
        Zusätze
      </ion-label>
      <ion-button slot="end" fill="clear" *ngIf="iZusaetze.length !== 0" size="small" style="font-size: smaller;" (click)="iZusaetze = [];">Alle einblenden</ion-button>
      <ion-button slot="end" fill="clear" *ngIf="iZusaetze.length === 0" size="small" style="font-size: smaller;" (click)="setAllZusaetzeInvisible();">Alle ausblenden</ion-button>
    </ion-item-divider>
    <ion-item *ngFor="let zusatz of zusaetze" (click)="toggleZusaetze(zusatz)">
      <ion-icon slot="start" [name]="iZusaetze.indexOf(zusatz) === -1 ? 'checkbox-outline' : 'square-outline'"></ion-icon>
      <ion-label>
        {{zusatz}}
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer>
  <ion-grid style="background-color: var(--ion-toolbar-background);">
    <ion-row>
      <ion-col>
        <ion-button expand="full" (click)="anwenden()">
          <div>
            Anwenden
          </div>
        </ion-button>
      </ion-col>
      <ion-col>
        <ion-button expand="full" (click)="abbrechen()" color="danger">
          <div>
            Abbrechen
          </div>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>